import { createSlice } from '@reduxjs/toolkit'
import Cookies from 'universal-cookie';

const cookies = new Cookies();

let initialLang = cookies.get('lang')
if (initialLang === undefined) {
  initialLang = 'en'
  cookies.set('lang', 'en', { path: '/' })
}

const initialState = {
  ids: ['en', 'tw', 'cn', 'vi'],
  languages: {
    en: { id: 'en', type: 'Languages', name: 'English' },
    tw: { id: 'tw', type: '語言', name: '中文繁體' },
    cn: { id: 'cn', type: '语言', name: '中文简体' },
    vi: { id: 'vi', type: 'Ngôn Ngữ', name: 'Tiếng Việt' },
  },
  currentLangId: initialLang,
  messages: {
    congratulation: {
      en: '🎉 You Win! Congratulation!!! 🎉',
      tw: '🎉 你贏了！恭喜！ 🎉',
      cn: '🎉 你赢了！恭喜！ 🎉',
      vi: '🎉 Bạn thắng! Chúc mừng !!! 🎉',
    },
    matched: {
      en: 'matched!',
      tw: '匹配成功!',
      cn: '匹配成功!',
      vi: 'phù hợp!',
    },
    again: {
      en: 'Play Again',
      tw: '再玩一次',
      cn: '再玩一次',
      vi: 'Chơi lại',
    },
    next: {
      en: 'Next Game',
      tw: '下一關',
      cn: '下一关',
      vi: 'Tiếp theo',
    }
  },
  nav: {
    home: {
      en: 'Home',
      tw: '首頁',
      cn: '首页',
      vi: 'Trang chủ',  
    },
    play: {
      en: 'PLAY',
      tw: '開始遊戲',
      cn: '开始游戏',
      vi: 'Chơi Game',  
    },
    start: {
      en: 'START',
      tw: '開始遊戲',
      cn: '开始游戏',
      vi: 'Chơi Game',  
    },
    about: {
      en: 'ABOUT',
      tw: '關於',
      cn: '关于',
      vi: 'Giới thiệu',  
    }
  },
  page: {
    about: {
      introduction: {
        en: 'Introduction',
        tw: '介紹',
        cn: '介绍',
        vi: 'Giới thiệu',
      },
      introductionParagraphy1: {
        en: 'VOCAFLIP is a memory game. It helps people to memorize vocabulary with gaming motivation. By clicking two cards to find a match of the same meaning of word and image, it collects a matched pair. Once you collect 12 matched pair, you win the game.',
        tw: 'VOCAFLIP 是一種記憶遊戲。 它可以幫助人們以遊戲的方式來記憶詞彙。 通過點擊兩張卡片來匹配相同含義的單詞和圖像。一旦收集到 12 對配對，您就贏得了比賽。',
        cn: 'VOCAFLIP 是一种记忆游戏。 它可以帮助人们以游戏的方式来记忆词汇。 通过点击两张卡片来匹配相同含义的单词和图像。一旦收集到 12 对配对，您就赢得了比赛。',
        vi: 'VOCAFLIP là một game trí nhớ. Nó giúp mọi người ghi nhớ từ vựng với động lực chơi game. Bằng cách nhấp vào hai thẻ để tìm một cặp có cùng nghĩa của từ và hình ảnh, nó sẽ thu thập một cặp phù hợp. Khi bạn thu thập được 12 cặp phù hợp, bạn sẽ giành chiến thắng trong trò chơi.',
      },
      history: {
        en: 'History',
        tw: '歷史',
        cn: '历史',
        vi: 'Lịch sử',
      },
      historyParagraphy1: {
        en: `Back to the date before the app was created, I was learning Vietnamese and struggled in memorizing vocabulary. Therefore, I decided to build this app. By coding and drawing illustration, I got a prototype version which built by Vue 2.x and Inkscape. Then, I continue to add more level into game, and also share the app on the internet.`,
        tw: '回想起這個App創建的前一天，我正在學習越南語並且在背單字這一方面很苦腦。 因此，我決定構建這個App。 通過編碼和繪製插圖，我製作了一個由 Vue 2.x 和 Inkscape 所構建的原型版本。 然後，我繼續在遊戲中添加更多關卡，並在網路上分享這個遊戲。',
        cn: '回想起这个App创建的前一天，我正在学习越南语并且在记忆词汇这一方面很苦脑。 因此，我决定构建这个App。 通过编码和绘制插图，我制作了一个由 Vue 2.x 和 Inkscape 所构建的原型版本。 然后，我继续在游戏中添加更多关卡，并在互联网上分享这个游戏。',
        vi: 'Quay lại thời điểm trước khi ứng dụng được tạo ra, tôi đang học tiếng Việt và gặp khó khăn trong việc ghi nhớ từ vựng. Do đó, tôi quyết định xây dựng ứng dụng này. Bằng cách viết mã và vẽ minh họa, tôi đã có một phiên bản nguyên mẫu được xây dựng bởi Vue 2.x và Inkscape. Sau đó, tôi tiếp tục thêm nhiều cấp độ vào trò chơi và cũng chia sẻ ứng dụng trên internet.',
      },
      historyParagraphy2: {
        en: `Recently, I found the App's UX needs to be improved, and I also want to learn React. For this reason, I refactor the app by React 17.x`,
        tw: '最近發現這個App的UX有待提升，而且剛好也想學React。 出於這個原因，我使用 React 17.x 重構了這個App',
        cn: '最近发现这个App的UX有待提升，而且刚好也想学React。 出于这个原因，我使用 React 17.x 重构了这个App',
        vi: 'Gần đây, tôi thấy UX của ứng dụng cần được cải thiện và tôi cũng muốn học React. Vì lý do này, tôi cấu trúc lại ứng dụng bằng React 17.x',
      },
      links: {
        en: 'Links',
        tw: '鏈接',
        cn: '链接',
        vi: 'Liên kết',
      },
      linksParagraphy1: {
        en: `If you like this game, consider to follow my channels:`,
        tw: '如果您喜歡這款遊戲，請考慮關注我的頻道：',
        cn: '如果您喜欢这款游戏，请考虑关注我的频道：',
        vi: 'Nếu bạn thích game này, hãy cân nhắc theo dõi các kênh của tôi:',
      }
    }
  }
}

const languagesSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    toLanguage(state, action) {
      state.currentLangId = action.payload
      cookies.set('lang', action.payload, { path: '/' })
    }
  }
})

export const { toLanguage } = languagesSlice.actions

export default languagesSlice.reducer

export const selectAllLanguageIds = state => state.languages.ids
export const selectAllLanguages = state => state.languages.languages
export const selectCurrentLangId = state => state.languages.currentLangId
export const selectMessages = state => {
  const lang = state.languages.currentLangId
  return Object.keys(state.languages.messages).reduce((res, key) => {
    res[key] = state.languages.messages[key][lang]
    return res
  }, {})
}
export const selectNav = state => {
  const lang = state.languages.currentLangId
  return Object.keys(state.languages.nav).reduce((res, key) => {
    res[key] = state.languages.nav[key][lang]
    return res
  }, {})
}
export const selectAboutPage = state => {
  const lang = state.languages.currentLangId
  return Object.keys(state.languages.page.about).reduce((res, key) => {
    res[key] = state.languages.page.about[key][lang]
    return res
  }, {})
}
